import React from 'react';
import { Link } from 'react-router-dom';

import './Header.css';
import logoUrl from 'assets/img/logo-black.png';

import Navigation from '../Navigation/Navigation';

class Header extends React.Component {
  render() {
    return (
      <header>
        <div className='Header-root' role='navigation'>
          <Link className='Header-companyLogo' to='/'>
            <img src={logoUrl} alt='TalentTribe' draggable='false' />
          </Link>
          <Navigation />
          <div className='Header-right'>

          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/global/Header/Header.js